import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function useCanonicalTag() {
    const location = useLocation();

    useEffect(() => {
        const canonicalUrl = `https://celeritas.live${location.pathname}`;

        let link = document.querySelector("link[rel='canonical']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'canonical';
            document.head.appendChild(link);
        }
        link.href = canonicalUrl;

        return () => {
            // Limpar canonical tag ao desmontar
            if (link) {
                link.remove();
            }
        };
    }, [location.pathname]);
}
